import { useState } from "react";
import { ListItem } from "../__shared__/ListItem/ListItem";
import { ArrowRightOutlined as ArrowRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ArrowRightOutlined";

import { PartnershipCardPointsSideDrawer } from "./components/SideDrawer/PartnershipCardPointsSideDrawer";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";

type Props = {
  /**
   * A number representing the points.
   */
  points: number;
  aprPercentage: string;
};

export const PartnershipCardPointsUI = ({ points, aprPercentage }: Props) => {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);

  const handleButtonClick = () => {
    dispatchMonetateQEvent("PartnershipCardPointsDrawerOpen");
    setDrawerOpen(true);
  };

  return (
    <>
      <ListItem
        trailingIcon={<ArrowRight size="medium" />}
        onClick={handleButtonClick}
        label={`Earn ${points} points when you pay for this product with your Partnership Credit Card. ${aprPercentage}% APR Representative (variable).`}
        description={
          "Credit subject to status. 18 years +. UK residents. T&Cs apply. John Lewis plc is a credit broker. NewDay Ltd is the lender."
        }
        dataComponent="PartnershipCardPoints"
      />
      <PartnershipCardPointsSideDrawer
        handleClose={() => setDrawerOpen(false)}
        drawerIsOpen={drawerOpen}
        points={points}
        aprPercentage={aprPercentage}
      />
    </>
  );
};
